import { render } from "./GrammarKnowledge.vue?vue&type=template&id=791afbb7&scoped=true"
import script from "./GrammarKnowledge.vue?vue&type=script&lang=js"
export * from "./GrammarKnowledge.vue?vue&type=script&lang=js"

import "./GrammarKnowledge.vue?vue&type=style&index=0&id=791afbb7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-791afbb7"]])

export default __exports__